import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { CheckResponseService, IReportProgress } from '@services/checkResponse/check-response.service';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-check-report-progress',
  templateUrl: './check-report-progress.component.html',
  styleUrls: ['./check-report-progress.component.scss'],
})
export class CheckReportProgressComponent implements OnInit, OnDestroy {
  /** Emitted once when the first multi-page load begins, so the host can dismiss any spinner. */
  @Output() public firstMultiPage = new EventEmitter<void>();

  /** Emitted when the user clicks Cancel. */
  @Output() public cancel = new EventEmitter<void>();

  public isVisible = false;
  public progressText = '';

  private subscription: Subscription | null = null;

  constructor(
    private checkResponseService: CheckResponseService,
    private translate: TranslateService
  ) {}

  ngOnInit(): void {
    this.subscription = this.checkResponseService.createProgressSubscription(
      (progress: IReportProgress, isFirstMultiPage: boolean) => {
        if (isFirstMultiPage) {
          this.firstMultiPage.emit();
        }
        this.isVisible = true;
        this.progressText = this.translate.instant(
          'REPORTING.Check_Report_Progress_Text',
          { pageNum: progress.pageNum, totalIDs: progress.totalIDs.toLocaleString() }
        );
      },
      () => {
        this.isVisible = false;
        this.progressText = '';
      }
    );
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
      this.subscription = null;
    }
  }

  public onCancel(): void {
    this.cancel.emit();
  }
}
